import { Container } from "react-bootstrap";

const classes = require("./PoliticasPrivacidad.module.css").default;

/**
 * Screen PoliticasPrivacidad
 * @description: Página de políticas de privacidad de SkyTechMP
 * @date 10/02/2026
 * @returns JSX del Screen
 */
const PoliticasPrivacidad = () => {
  return (
    <div className={classes.container}>
      <Container>
        <div className={classes.content}>
          <h1>Políticas de Privacidad</h1>
          <p className={classes.lastUpdate}>
            Última actualización: 10 de febrero de 2026
          </p>

          <section>
            <h2>1. Información General</h2>
            <p>
              SkyTech Management Platform (en adelante "SkyTechMP" o "la
              Plataforma") es un sistema de gestión de servicios técnicos para
              instalación y mantenimiento de dispositivos GPS en unidades
              vehiculares, operado por SkyAngel.
            </p>
            <p>
              Nos comprometemos a proteger la privacidad y seguridad de la
              información personal de nuestros usuarios, clientes y sus
              contactos.
            </p>
          </section>

          <section>
            <h2>2. Información que Recopilamos</h2>
            <h3>2.1 Información de Usuarios del Sistema</h3>
            <ul>
              <li>Nombre completo (nombre, apellido paterno y materno)</li>
              <li>Correo electrónico corporativo</li>
              <li>Rol y permisos asignados</li>
              <li>Plataformas de acceso autorizadas</li>
              <li>Historial de actividades en el sistema</li>
            </ul>

            <h3>2.2 Información de Clientes y Empresas</h3>
            <ul>
              <li>Razón social y nombre comercial</li>
              <li>Datos de sucursales (domicilios y coordenadas)</li>
              <li>Información de contactos (nombres, correos, teléfonos)</li>
              <li>Datos de unidades vehiculares (VIN, placas, modelo, color, económico)</li>
            </ul>

            <h3>2.3 Información de Servicios Técnicos</h3>
            <ul>
              <li>Órdenes de servicio y folios</li>
              <li>Fechas y horarios de servicios programados</li>
              <li>Observaciones y notas técnicas</li>
              <li>Fotografías de instalaciones y equipos</li>
              <li>Información de dispositivos GPS instalados</li>
              <li>Datos de cobros y pagos</li>
            </ul>

            <h3>2.4 Información Técnica</h3>
            <ul>
              <li>Dirección IP</li>
              <li>Tipo de navegador</li>
              <li>Fecha y hora de acceso</li>
              <li>Páginas visitadas dentro del sistema</li>
            </ul>
          </section>

          <section>
            <h2>3. Uso de la Información</h2>
            <p>Utilizamos la información recopilada para:</p>
            <ul>
              <li>Gestionar y administrar servicios técnicos de instalación y mantenimiento</li>
              <li>Programar y coordinar visitas técnicas</li>
              <li>Generar reportes y documentación de servicios</li>
              <li>Procesar cobros y pagos de servicios</li>
              <li>Mantener un historial de servicios por cliente y unidad</li>
              <li>Controlar accesos y permisos de usuarios</li>
              <li>Generar métricas y estadísticas operativas</li>
              <li>Mejorar la calidad del servicio</li>
              <li>Cumplir con obligaciones legales y contractuales</li>
            </ul>
          </section>

          <section>
            <h2>4. Compartir Información</h2>
            <p>
              No vendemos, alquilamos ni compartimos información personal con
              terceros, excepto en los siguientes casos:
            </p>
            <ul>
              <li>
                <strong>Con clientes autorizados:</strong> Los clientes tienen
                acceso a la información de sus propias unidades y servicios
              </li>
              <li>
                <strong>Con técnicos asignados:</strong> Personal técnico
                autorizado accede a información necesaria para realizar
                servicios
              </li>
              <li>
                <strong>Requerimientos legales:</strong> Cuando sea requerido
                por ley o autoridad competente
              </li>
              <li>
                <strong>Proveedores de servicios:</strong> Proveedores que nos
                ayudan a operar la plataforma bajo acuerdos de
                confidencialidad
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Seguridad de la Información</h2>
            <p>Implementamos medidas de seguridad que incluyen:</p>
            <ul>
              <li>Autenticación mediante tokens JWT</li>
              <li>Conexiones cifradas mediante HTTPS/SSL</li>
              <li>Sistema de permisos granulares por rol</li>
              <li>Control de acceso basado en plataformas</li>
              <li>Registro de auditoría de actividades</li>
              <li>Respaldos periódicos de información</li>
              <li>Almacenamiento seguro de contraseñas (hash)</li>
            </ul>
          </section>

          <section>
            <h2>6. Retención de Datos</h2>
            <p>
              Conservamos la información personal durante el tiempo necesario
              para cumplir con los propósitos descritos en esta política, a
              menos que la ley requiera o permita un período de retención más
              prolongado.
            </p>
            <ul>
              <li>
                <strong>Datos de servicios:</strong> Se mantienen
                indefinidamente para historial y garantías
              </li>
              <li>
                <strong>Datos de usuarios inactivos:</strong> Se conservan
                durante 2 años después de la última actividad
              </li>
              <li>
                <strong>Registros de auditoría:</strong> Se mantienen por 5
                años
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Derechos de los Usuarios</h2>
            <p>Los usuarios tienen derecho a:</p>
            <ul>
              <li>Acceder a su información personal almacenada</li>
              <li>Solicitar corrección de datos inexactos</li>
              <li>Solicitar eliminación de datos (sujeto a obligaciones legales)</li>
              <li>Oponerse al procesamiento de sus datos</li>
              <li>Solicitar portabilidad de datos</li>
              <li>Revocar consentimientos otorgados</li>
            </ul>
            <p>
              Para ejercer estos derechos, contactar a:{" "}
              <a href="mailto:privacidad@skyangel.com.mx">
                privacidad@skyangel.com.mx
              </a>
            </p>
          </section>

          <section>
            <h2>8. Cookies y Tecnologías Similares</h2>
            <p>
              Utilizamos localStorage del navegador para mantener la sesión
              activa y mejorar la experiencia del usuario. Esta información se
              almacena localmente en su dispositivo y puede ser eliminada en
              cualquier momento desde la configuración de su navegador.
            </p>
          </section>

          <section>
            <h2>9. Transferencias Internacionales</h2>
            <p>
              Los datos se almacenan y procesan en servidores ubicados en
              México. No realizamos transferencias internacionales de datos sin
              el consentimiento explícito del usuario.
            </p>
          </section>

          <section>
            <h2>10. Menores de Edad</h2>
            <p>
              SkyTechMP es una plataforma empresarial B2B. No recopilamos
              intencionalmente información de menores de 18 años.
            </p>
          </section>

          <section>
            <h2>11. Cambios a esta Política</h2>
            <p>
              Nos reservamos el derecho de actualizar esta política de
              privacidad. Los cambios significativos serán notificados a través
              del sistema con al menos 30 días de anticipación.
            </p>
          </section>

          <section>
            <h2>12. Contacto</h2>
            <p>
              Para preguntas, comentarios o solicitudes relacionadas con esta
              política de privacidad:
            </p>
            <ul>
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:privacidad@skyangel.com.mx">
                  privacidad@skyangel.com.mx
                </a>
              </li>
              <li>
                <strong>Sitio web:</strong>{" "}
                <a
                  href="https://skyangel.com.mx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://skyangel.com.mx
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2>13. Cumplimiento Legal</h2>
            <p>
              Esta política cumple con la Ley Federal de Protección de Datos
              Personales en Posesión de los Particulares (LFPDPPP) de México y
              sus reglamentos aplicables.
            </p>
          </section>
        </div>
      </Container>
    </div>
  );
};

export default PoliticasPrivacidad;
